import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { getTreesloLogoPath } from "../../../../core/branding.model";
import {
  LANDING_1_FOOTER_COLUMNS,
  LANDING_1_FOOTER_CONTACT_EMAIL,
  type Landing1FooterLink,
} from "../../landing-1.section-data";
import { landingAppUrlWithReturn } from "../../../../shared/landing-app-url.constant";

@Component({
  selector: "app-landing-1-footer",
  standalone: true,
  imports: [TranslateModule],
  templateUrl: "./landing-1-footer.component.html",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Landing1FooterComponent {
  readonly heroLogoSrc = getTreesloLogoPath("large", "dark");
  readonly footerColumns = LANDING_1_FOOTER_COLUMNS;

  footerLinkHref(link: Landing1FooterLink): string {
    if (link.mailto) {
      const email = LANDING_1_FOOTER_CONTACT_EMAIL.trim();
      return email ? `mailto:${email}` : "#";
    }

    return landingAppUrlWithReturn(link.path);
  }
}
